module.exports = __webpack_public_path__ + "static/media/coffee.e43596f0.svg";